import script from "./ApplicationMigrationView.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplicationMigrationView.vue?vue&type=script&setup=true&lang=js"

import "./ApplicationMigrationView.vue?vue&type=style&index=0&id=3594ca36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3594ca36"]])

export default __exports__